import { useEffect, useState } from "react"

// FIQ-682: lets an audit host display a just-saved reason/rejection immediately. The server copy of
// a tailoring audit only refreshes when the invalidation-driven refetch lands (multi-second on large
// regimes); until then the save looked like it hadn't worked and the "add justification" button
// reappeared. The reason/rejection mutations return the stored Audit — hosts bind the setter as
// `setTailoringAudit`, and EditAuditReason / RemoveJustification push the mutation result into it.
// Any refetch that then delivers a fresh server copy (which already includes the write, because the
// invalidation fires after it) clears the override.
export function useOptimisticTailoringAudit(serverAudit) {
    const [localAudit, setLocalAudit] = useState(null)

    // Clear the override whenever a fresh server copy arrives
    useEffect(() => setLocalAudit(null), [serverAudit])

    return [localAudit ?? serverAudit, setLocalAudit]
}
